/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
import { useNavigate, useLocation, createSearchParams } from 'react-router-dom';
import React, { useState } from 'react';
import dayjs from 'dayjs';
import 'react-simple-keyboard/build/css/index.css';
import {
  Box,
  Center,
  Stack,
  Button,
  Title,
  Text,
  ActionIcon,
  Group,
  Divider,
  Space,
  Image,
  Paper,
} from '@mantine/core';

import backButton from '../../image/backArrow.png';
import CarArrow from '../../image/car-arrow.png';
import PrimaryButton from '../../components/GroupButton';

const UserDetails = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const NumberPlate = searchParams.get('numberPlate');
  const userName = searchParams.get('name');
  const Mobile = searchParams.get('mobile');
  const Price = searchParams.get('sitePrice');
  const vasQty = searchParams.get('vas_qty');
  const vasId = searchParams.get('vasTypeId');
  const vasType = searchParams.get('vasName');
  const VarsPrice = searchParams.get('vasTypesPrice');
  const taxData = searchParams.get('taxData');
  const carWashInside = searchParams.get('carWashValue1');
  const carWashOutside = searchParams.get('carWashValue2');
  const carWashBoth = searchParams.get('carWashValue3');

  const [ticketData, setTicketData] = useState();

  const posPayment = () => {
    navigate({
      pathname: '/insertcard',
      search: createSearchParams({
        passId: 1660004845026,
      }).toString(),
    });
  };

  const goBack = () => {
    navigate({
      pathname: '/services',
      search: createSearchParams({
        vasName: vasType,
        vasTypeId: vasId,
        vasTypesPrice: VarsPrice,
        sitePrice: Price,
        numberPlate: NumberPlate,
        tax: taxData,
        carWashValue1: carWashInside,
        carWashValue2: carWashOutside,
        carWashValue3: carWashBoth,
        vas_qty: vasQty,
        name: userName,
        mobile: Mobile,
      }).toString(),
    });
  };

  const startDate = dayjs(ticketData?.start_time).format('DD-MM-YYYY HH:mm').slice(0, -5);
  const startTime = dayjs(ticketData?.start_time).format('DD-MM-YYYY HH:mm').slice(10);

  const endDate = dayjs(ticketData?.end_time).format('DD-MM-YYYY HH:mm').slice(0, -5);
  const endTime = dayjs(ticketData?.end_time).format('DD-MM-YYYY HH:mm').slice(10);

  const date1 = dayjs(startDate);
  const date2 = dayjs(endDate);
  const diff = date2.diff(date1, 'day', true);
  const days = Math.floor(diff);
  const hours = Math.floor((diff - days) * 24);
  return (
    <Box>
      <Group>
        <Button
          onClick={goBack}
          color="blue"
          radius="md"
          size="xl"
          leftIcon={<Image src={backButton} width={35} height={20} />}
          px="xl"
        />
        <Space w="xl" />
        <Space w="xl" />
        <Space w="xl" />
        <Space w="xl" />
        <Space w="xl" />
        <Space w="xl" />
        <Center px="xl">
          <Title style={{ color: '#F9D923' }} order={1}>
            Ticket Details
          </Title>
        </Center>
      </Group>
      <Center>
        <Stack>
          <div>
            <Paper shadow="lg" withBorder p="xl">
              <Stack>
                <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                  <Text size="sm" weight={500} color="#817E7E">
                    Welcome {userName}
                  </Text>
                  <Text size="sm" weight={500} color="#817E7E">
                    Plate: {NumberPlate}
                  </Text>
                </Group>

                <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                  <Group>
                    <Stack>
                      <Center>
                        <Title size="sm" order={2}>
                          Entry
                        </Title>
                      </Center>
                      <Center>
                        <Text size="sm" weight={500}>
                          {startDate}
                        </Text>
                      </Center>
                      <Center>
                        <Text size="sm" weight={500}>
                          {startTime}
                        </Text>
                      </Center>
                    </Stack>
                  </Group>
                  <Image src={CarArrow} />
                  <Group>
                    <Stack>
                      <Center>
                        <Title size="sm" order={2}>
                          Exit
                        </Title>
                      </Center>
                      <Center>
                        <Text size="sm" weight={500}>
                          {endDate}
                        </Text>
                      </Center>
                      <Center>
                        <Text size="sm" weight={500}>
                          {endTime}
                        </Text>
                      </Center>
                    </Stack>
                    <ActionIcon
                      color="dark"
                      size="xl"
                      radius="xl"
                      variant="default"
                      sx={{
                        borderColor: 'black',
                        width: '80px',
                        height: '80px',
                        borderRadius: '50px',
                      }}
                    >
                      <Text weight={900} size="lg">
                        {hours} hrs
                      </Text>
                    </ActionIcon>
                  </Group>
                </Group>
                <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                  <Stack>
                    <Title size="sm" order={2}>
                      Description
                    </Title>
                    <Text size="sm" weight={500} color="#817E7E">
                      {hours} hours Parking
                    </Text>
                    <Group>
                      <Text size="sm" weight={500} color="#817E7E">
                        {vasType}
                      </Text>
                      {vasId !== '24' ? (
                        <Text size="sm" weight={400} color="#817E7E">
                          X {vasQty}
                        </Text>
                      ) : vasId !== '2' || '3' ? (
                        <Text size="sm" weight={400} color="#817E7E">
                          <Group>
                            {carWashInside === 'true' ? (
                              <Text size="sm" weight={400} color="#817E7E">
                                Inside ,
                              </Text>
                            ) : null}
                            {carWashOutside === 'true' ? (
                              <Text size="sm" weight={400} color="#817E7E">
                                Outside ,
                              </Text>
                            ) : null}
                            {carWashBoth === 'true' ? (
                              <Text size="sm" weight={400} color="#817E7E">
                                Both ,
                              </Text>
                            ) : null}
                          </Group>
                        </Text>
                      ) : null}
                    </Group>
                    <Text size="sm" weight={500} color="#817E7E">
                      Tax
                    </Text>
                  </Stack>
                  <Space w="xl" />
                  <Space w="xl" />
                  <Space w="xl" />
                  <Stack>
                    <Title size="sm" order={2}>
                      Amount
                    </Title>
                    <Text size="sm" weight={500} color="#817E7E">
                      {Price}
                      SAR
                    </Text>

                    <Text size="sm" weight={500} color="#817E7E">
                      {VarsPrice} SAR
                    </Text>

                    {ticketData?.vas_orders.map((item) => (
                      <Text size="sm" weight={500} color="#817E7E">
                        {item?.amount} SAR
                      </Text>
                    ))}
                    <Text size="sm" weight={500} color="#817E7E">
                      {taxData === undefined || null ? 0 : taxData} SAR
                    </Text>
                  </Stack>
                </Group>
                <Divider size="sm" />
                <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                  <Title size="sm" order={2}>
                    Total
                  </Title>
                  <Title size="sm" order={2}>
                    {Number(Price) + Number(VarsPrice) + Number(taxData)} SAR
                  </Title>
                </Group>
                <Button onClick={posPayment} sx={{ backgroundColor: '#01AA84' }} size="xl">
                  Pay
                </Button>
              </Stack>
            </Paper>
          </div>
        </Stack>
      </Center>
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />

      <PrimaryButton />

      {/* <SimpleGrid cols={4} position="apart" px="xl">
        <Button
          color="blue"
          radius="md"
          size="xl"
          style={{
            width: '200px',
            height: '70px',
            backgroundColor: '#4D6D78',
            position: 'fixed',
            left: 100,
            bottom: 55,
          }}

          // onClick={changeLanguageHandler('en')}
        >
          <Title order={1}>عربي</Title>
        </Button> */}
      {/* <select className="custom-select" style={{ width: 200 }} onChange={changeLanguageHandler}>
          <option value="en">English</option> <option value="ar">Arabic</option>
        </select> */}
      {/* <div />
        <div />
        <Button
          onClick={() => navigate('/')}
          color="blue"
          radius="md"
          size="xl"
          style={{
            width: '200px',
            height: '70px',
            backgroundColor: '#4D6D78',
            position: 'fixed',
            right: 100,
            bottom: 55,
          }}
        >
          <Title order={1}>Home</Title>
        </Button>
      </SimpleGrid> */}
    </Box>
  );
};

export default UserDetails;
